<app-header />

<div class="min-h-screen bg-gray-50 flex items-start justify-center pt-8 pb-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <div>
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Cambiar contrasena
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        Actualiza tu contrasena actual por una nueva.
      </p>
    </div>

    @if (!passwordUpdated) {
      <form class="mt-8 space-y-6" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="rounded-md shadow-sm space-y-4">
          <div>
            <label for="currentPassword" class="block text-sm font-medium text-gray-700 mb-1">
              Contrasena actual
            </label>
            <input
              id="currentPassword"
              name="currentPassword"
              type="password"
              formControlName="currentPassword"
              class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg focus:outline-none focus:ring-[#e8343f] focus:border-[#e8343f] focus:z-10 sm:text-sm"
              [class.border-red-500]="isFieldInvalid('currentPassword')"
              placeholder="Tu contrasena actual"
            />
          </div>
          <div>
            <label for="newPassword" class="block text-sm font-medium text-gray-700 mb-1">
              Nueva contrasena
            </label>
            <input
              id="newPassword"
              name="newPassword"
              type="password"
              formControlName="newPassword"
              class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg focus:outline-none focus:ring-[#e8343f] focus:border-[#e8343f] focus:z-10 sm:text-sm"
              [class.border-red-500]="isFieldInvalid('newPassword')"
              placeholder="Minimo 8 caracteres"
            />
            @if (isFieldInvalid('newPassword')) {
              <p class="mt-1 text-sm text-red-600">La contrasena debe tener mayusculas, minusculas y numeros</p>
            }
            @if (form.get('newPassword')?.value) {
              <div class="mt-2">
                <div class="flex items-center space-x-2">
                  <div class="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      class="h-full transition-all duration-300"
                      [class.w-1/3]="passwordStrength === 'weak'"
                      [class.w-2/3]="passwordStrength === 'medium'"
                      [class.w-full]="passwordStrength === 'strong'"
                      [class.bg-red-500]="passwordStrength === 'weak'"
                      [class.bg-yellow-500]="passwordStrength === 'medium'"
                      [class.bg-green-500]="passwordStrength === 'strong'"
                    ></div>
                  </div>
                  <span class="text-xs font-medium"
                    [class.text-red-500]="passwordStrength === 'weak'"
                    [class.text-yellow-500]="passwordStrength === 'medium'"
                    [class.text-green-500]="passwordStrength === 'strong'"
                  >
                    @if (passwordStrength === 'weak') { Debil }
                    @if (passwordStrength === 'medium') { Media }
                    @if (passwordStrength === 'strong') { Fuerte }
                  </span>
                </div>
              </div>
            }
          </div>
          <div>
            <label for="confirmPassword" class="block text-sm font-medium text-gray-700 mb-1">
              Confirmar contrasena
            </label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              formControlName="confirmPassword"
              class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg focus:outline-none focus:ring-[#e8343f] focus:border-[#e8343f] focus:z-10 sm:text-sm"
              [class.border-red-500]="passwordMismatch"
              placeholder="Repite tu contrasena"
            />
            @if (passwordMismatch) {
              <p class="mt-1 text-sm text-red-600">Las contrasenas no coinciden</p>
            }
          </div>
        </div>

        @if (errorMessage) {
          <div class="rounded-md bg-red-50 p-4">
            <p class="text-sm font-medium text-red-800">{{ errorMessage }}</p>
          </div>
        }

        <button
          type="submit"
          [disabled]="isLoading"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-[#e8343f] hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e8343f] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          @if (isLoading) {
            Guardando...
          } @else {
            Guardar cambios
          }
        </button>

        <div class="text-center text-sm">
          <a routerLink="/profile" class="font-medium text-[#e8343f] hover:text-red-700">
            Volver al perfil
          </a>
        </div>
      </form>
    } @else {
      <div class="rounded-md bg-green-50 p-4">
        <p class="text-sm font-medium text-green-800">{{ successMessage }}</p>
      </div>
      <div class="text-center text-sm">
        <a routerLink="/profile" class="font-medium text-[#e8343f] hover:text-red-700">
          Volver al perfil
        </a>
      </div>
    }
  </div>
</div>

<app-footer />
